import clsx from 'clsx';
import { useField } from 'formik';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { AssessmentSectionQuestion } from 'types';
import AssessmentScore from 'components/common/AssessmentScore';
import { convertPointsToScore } from '../assessment-util';

const QuestionButton = (props: { question: AssessmentSectionQuestion }) => {
  //  eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helpers] = useField(props.question.assessmentQuestion.id.toString());
  const { setValue } = helpers;
  const classes = useStyles();
  const options = props.question.assessmentQuestion.answerType.options;
  const currentAnswer = options.find((o) => o.id.toString() === field.value);

  return (
    <div
      className={clsx(
        classes.btnScoring,
        !currentAnswer
          ? classes.borderNotObserved
          : currentAnswer?.pointValue === 3
          ? classes.borderYes
          : currentAnswer.pointValue === 2 || currentAnswer.pointValue === 1
          ? classes.borderSomewhat
          : classes.borderNo
      )}
      onClick={() => {
        const currIndex = options.findIndex((o) => o.id.toString() === field.value);
        const newVal =
          currIndex === -1
            ? options[0].id.toString()
            : currIndex === options.length - 1
            ? ''
            : options[currIndex + 1].id.toString();
        setValue(newVal);
      }}
    >
      <p>{props.question.assessmentQuestion.text}</p>
      <AssessmentScore score={convertPointsToScore(currentAnswer?.pointValue)} />
    </div>
  );
};

export default QuestionButton;

const useStyles = makeStyles((theme: Theme) => {
  return {
    btnScoring: {
      display: 'grid',
      gridTemplateColumns: '1fr 48px',
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(2),

      '& p': {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        paddingRight: theme.spacing(2),
        margin: 0,
      },
    },
    borderYes: {
      border: '2px solid #098e51',
    },
    borderSomewhat: {
      border: '2px solid #6c820c',
    },
    borderNo: {
      border: '2px solid #e86825',
    },
    borderNotObserved: {
      border: '2px solid #0c72b7',
    },
  };
});
